import React, { useState } from 'react';
import formatNumber from '../utils/formatNumber';
import OneTouristTour from './OneTouristTour';

const OneTouristGroupByRoomTours = ({
  row,
  room,
  hideoperator = false,
  row_fix,
  request_model,
  likes,
  carts,
  setTourToShare,
  setOpenModal,
  groupedTours,
  setTourToCart,
  setTourLike,
  handleOfficeSave,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="tours__group-header" onClick={() => setIsOpen(!isOpen)}>
        <div style={{ paddingRight: '120px' }}>
          {room} ({groupedTours[room].length})
        </div>{' '}
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '10px',
            fontWeight: 'bold',
          }}
        >
          от {formatNumber(groupedTours[room][0].price)}{' '}
          {groupedTours[room][0].currency === 'RUB'
            ? `₽`
            : groupedTours[room][0].currency}
        </span>
      </div>
      {isOpen ? (
        <div className="hotel_hidden_list1">
          {groupedTours[room].map((tour) => (
            <OneTouristTour
              key={`group-${tour.tourid}`}
              request_model={request_model}
              row_fix={row_fix}
              row={row}
              hideoperator={hideoperator}
              tour={tour}
              likes={likes}
              carts={carts}
              setTourToShare={setTourToShare}
              setOpenModal={setOpenModal}
              setTourToCart={setTourToCart}
              setTourLike={setTourLike}
              handleOfficeSave={handleOfficeSave}
            />
          ))}
        </div>
      ) : null}
    </>
  );
};

export default OneTouristGroupByRoomTours;
